<div class="flex md:flex-row flex-col gap-4">

  <div class="md:w-1/2 w-full h-96 p-4 md:p-0 relative">
    <canvas baseChart
            type="bar"
            [data]="chartData()"
            [options]="chartOptions()"
            class="w-full h-full">
    </canvas>

    @if (loading) {
      <div class="absolute inset-0 flex items-center justify-center bg-white dark:bg-black pointer-events-none select-none">
        <div class="flex items-center space-x-2 text-gray-700 text-sm">
          <svg class="animate-spin h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <span>…</span>
        </div>
      </div>
    }
  </div>

  <div class="md:w-1/2 w-full md:p-0 md:pt-2 pb-0">

    <button
      class="w-full pl-4 mt-2.5 md:mt-0 text-left font-medium flex justify-between items-center border-t border-gray-200"
      (click)="toggleDailyDetailsAccordion()">
      <h2 class="font-medium">Details</h2>
      <span class="transform transition-transform">
        <mat-icon
          class="transition-transform duration-300 size-12 text-4xl align-middle text-center pt-1"
          [class.rotate-180]="isDailyAccordionOpen">
          {{ isDailyAccordionOpen ? 'remove' : 'add' }}
        </mat-icon>
      </span>
    </button>

    <div class="p-2 mb-12" [class.hidden]="!isDailyAccordionOpen">
      <table class="w-full border-collapse">
        <thead>
          <tr>
            <th class="text-left p-1"></th>
            <th class="text-right p-1">kWh</th>
          </tr>
        </thead>
        <tbody>
          @for (dataRow of balanceData; track dataRow) {
            @for (row of dataRow; track row) {
              <tr [class.border-b]="row.isDate" [class.border-gray-200]="row.isDate">
                <td class="p-1" [class.font-bold]="row.isTotal" [class.pt-8]="row.isTotal && !row.isFirstElement"
                    [class.pt-8]="row.isDate" [class.text-lg]="row.isDate">{{ row.label }}
                </td>
                <td class="text-right p-1" [class.font-bold]="row.isTotal"
                    [class.pt-8]="row.isTotal && !row.isFirstElement"
                    [class.pt-8]="row.isDate" [class.text-lg]="row.isDate"
                    [class.text-red-500]="row.isDifferent">{{ row.value }}
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="md:w-full w-full p-0 mb-8 pt-0">

      <button
        class="w-full pl-4 text-left font-medium flex justify-between items-center border-t border-b border-gray-200"
        (click)="toggleIndependenceAccordion()">
        <h2 class="font-medium">Unabhängigkeit</h2>
        <span class="transform transition-transform">
          <mat-icon
            class="transition-transform duration-300 size-12 text-4xl align-middle text-center pt-1"
            [class.rotate-180]="isIndependenceAccordionOpen">
            {{ isIndependenceAccordionOpen ? 'remove' : 'add' }}
          </mat-icon>
        </span>
      </button>

      <div class="p-4 pt-0" [class.hidden]="!isIndependenceAccordionOpen">
        <table class="w-full border-collapse independencetable">
          <tbody>
            @for (dataRow of independenceData; track dataRow) {
              @for (row of dataRow; track row) {
                <tr [class.border-b]="row.isDate" [class.border-gray-200]="row.isDate">
                  <td class="p-1" [class.font-bold]="row.isTotal"
                      [class.pt-4]="row.isTotal"
                      [class.text-sm]="row.isTotal"
                      [class.pt-8]="row.isDate" [class.text-lg]="row.isDate" [innerHTML]="row.label">
                  </td>
                  <td class="text-right p-1" [class.font-bold]="row.isTotal"
                      [class.pt-4]="row.isTotal"
                      [class.text-sm]="row.isTotal"
                      [class.pt-8]="row.isDate" [class.text-lg]="row.isDate"
                      [class.text-red-500]="row.isDifferent">{{ row.value }}
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

    </div>
  </div>

</div>
